"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageLoader_1 = require("../../components/PageLoader");
require("picturefill");
PageLoader_1.PageLoader.each('.search-results');
PageLoader_1.PageLoader.each('.dossier-articles', {
    useCache: false
});
PageLoader_1.PageLoader.each('.program-articles', {
    useCache: false
});
PageLoader_1.PageLoader.each('.past-events', {
    useCache: false
});
PageLoader_1.PageLoader.each('.columnist-articles', {
    useCache: false
});
PageLoader_1.PageLoader.each('.podcast-articles', {
    useCache: false
});
PageLoader_1.PageLoader.each('.my-news-overview', {
    busBindings: {
        reset: ['interest.added', 'interest.deleted']
    },
    useCache: false,
    onUpdate: function () {
        if (!this.el.find(".results > article").length) {
            jQuery(".onboarding").removeClass("hidden");
        }
    }
});
PageLoader_1.PageLoader.getBus().listen("content.updated", function () {
    picturefill();
    imgix.init();
});
